const ORCHESTRATOR_PATH = '/ecommerce'

/**
 * Creates a url based on the url prefix
 *
 * @param {string} urlPrefix
 */
const getBaseUrl = (urlPrefix) => {
  let url = ORCHESTRATOR_PATH // All urls will route through orchestrator now
  url = buildPrefix(urlPrefix, url)
  return url
}

/**
 * builds a url based on the urlPrefix
 * (`uk`, `de`, `fr`) existence or not
 *
 * @param {string} urlPrefix
 * @param {string} url
 */
const buildPrefix = (urlPrefix, url = '') => {
  if (urlPrefix.length) {
    url = `${url}/${urlPrefix}`
  }
  return url
}

export const getParameterByName = (name, url = window.location.href) => {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export { getBaseUrl }
